module.exports = __webpack_public_path__ + "35705faeaeedec8daece5694ed998511.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/lawbreakers/promenade.png
// module id = 1072
// module chunks = 0